/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type BulkEmailType from '@jira/admin-pages__bulk-email-page/src/BulkEmailPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyBulkEmail: LazyComponent<typeof BulkEmailType> = lazyForPaint<
	typeof BulkEmailType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-bulk-email", jiraSpaEntry: "jira-admin-pages-bulk-email" */ '@jira/admin-pages__bulk-email-page/src/BulkEmailPage.tsx'
		),
	),
);

const AsyncBulkEmail = (): React.JSX.Element => (
	<LazyPage Page={LazyBulkEmail} pageId="jira-admin-pages-bulk-email" shouldShowSpinner />
);

export default AsyncBulkEmail;
